import { useMediaQuery } from 'react-responsive';
import Chat from './Chat';
import MobileChatView from './MobileChatView';
import { useProduct } from '../../context/ProductContext';

const SiteRouter = () => {
  const { setProduct } = useProduct();
  setProduct('bot-canvas')
  const isMobile = useMediaQuery({ maxWidth: 768 }); // adjust breakpoint if needed

  return isMobile ? <MobileChatView /> : <Chat />;
};

export default SiteRouter;
